"use client";
// import { Power0 } from "gsap";
import { useState, useEffect } from "react";
import {  FaDollarSign } from "react-icons/fa";
import Image from "next/image";

const benefits = [
  {
    id: 1,
    // icon: FaShield,
    title: "Smart Dry Run Protection",
    subtitle: "Your Motor's Guardian Angel",
    description: "Advanced sensors detect low water levels instantly, preventing costly motor damage. Our intelligent system automatically stops operation when water flow is insufficient, extending motor life by up to 300%.",
    keyFeatures: [
      "Instant water level detection",
      "Automatic motor shutdown",
      "Prevents overheating damage",
      "Extends motor lifespan"
    ],
    image: "/1.png",
    color: "black",
    bgColor: "bg-white-50"
  },
  {  
    id: 2,
    // icon: FaMobile,
    title: "Remote Mobile Control",
    subtitle: "Farm Control in Your Pocket",
    description: "Control your motor from anywhere using our smart app, SMS, or simple phone calls. Whether you're at home or away, manage your irrigation with just a tap or text message.",
    keyFeatures: [
      "Phone call control",
      "SMS commands",
      "Voice call control (IVRS)",
      "Real-time status updates"
    ],
    image: "/2.png",
    color: "black",
    bgColor: "bg-white-50"
  },
  {
    id: 3,
    // icon: FaClock,
    title: "Time & Effort Saver",
    subtitle: "Focus on What Matters",
    description: "Automate your irrigation schedule and eliminate manual monitoring. Save up to 4 hours daily with intelligent automation that runs your farm operations seamlessly.",
    keyFeatures: [
      "Automated scheduling",
      "No manual intervention",
      "Smart monitoring",
      "Stress-free operation"
    ],
    image: "/1.png",
    color: "black",
    bgColor: "bg-white-50"
  },
  {
    id: 4,
    // icon: FaBolt,
    title: "Complete Safety Shield",
    subtitle: "Zero Risk Operation",
    description: "Advanced electrical protection systems prevent shocks, voltage damage, and equipment failure. Multiple safety layers ensure 100% secure operation for you and your family.",
    keyFeatures: [
      "Electrical shock protection",
      "Voltage fluctuation guard",
      "Overload protection",
      "Safe remote operation"
    ],
    image: "/2.png",  
    color: "black",
    bgColor: "white"
  },
  {
    id: 5,
    // icon: FaAward,
    title: "1-Year Full Guarantee & 24/7 Support",
    subtitle: "Quality You Can Trust",
    description: "Comprehensive 1-year Guarantee covering all components and free service support. We stand behind our product with complete confidence in its reliability and performance.",
    keyFeatures: [
      "Full component coverage",
      "Free service support",
      "Replacement guarantee",
      "24/7 customer support"
    ],
    image: "/mobile5.png",
    color: "black",
    bgColor: "white"
  },
  {
    id: 6,
    icon: FaDollarSign,
    title: "Smart Investment",
    subtitle: "Save Money, Boost Productivity",
    description: "Reduce electricity bills by 30% and cut maintenance costs by 50%. Smart automation optimizes energy usage while preventing costly motor repairs and replacements.",
    keyFeatures: [
      "30% electricity savings",
      "50% lower maintenance",
      "Prevents costly repairs",
      "Quick ROI in 6 months"
    ],
    image: "/mobile5.png",
    color: "black",
    bgColor: "white"
  }
];

export default function ModernProductBenefits() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isAutoPlaying, setIsAutoPlaying] = useState(true);

  // Auto-slide functionality
  useEffect(() => {
    if (!isAutoPlaying) return;
    
    const timer = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % benefits.length);
    }, 8000);

    return () => clearInterval(timer);
  }, [isAutoPlaying]);

  // const handleNext = () => {
  //   setCurrentIndex((prevIndex) => (prevIndex + 1) % benefits.length);
  //   setIsAutoPlaying(false);
  // };

  // const handlePrevious = () => {
  //   setCurrentIndex((prevIndex) =>
  //     prevIndex === 0 ? benefits.length - 1 : prevIndex - 1
  //   );
  //   setIsAutoPlaying(false);
  // };

  // interface Benefit {
  //   id: number;
  //   icon?: React.ComponentType<unknown>;
  //   title: string;
  //   subtitle: string;
  //   description: string;
  //   keyFeatures: string[];
  //   image: string;
  //   color: string;
  //   bgColor: string;
  // }

  const handleDotClick = (index: number): void => {
    setCurrentIndex(index);
    setIsAutoPlaying(false);
  };

  const currentBenefit = benefits[currentIndex];

  return (
    <section className="relative py-16 bg-gradient-to-br from-gray-50 to-white overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-5">
        {/* <div className="absolute inset-0" style={{
          backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23000000' fill-opacity='0.1'%3E%3Ccircle cx='30' cy='30' r='2'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`
        }}></div> */}
      </div>

      <div className="container mx-auto px-4 lg:px-8 relative z-10">
        {/* Header */}
        <div className="text-center mb-16">
          {/* <div className="inline-flex items-center justify-center w-16 h-16 bg-gradient-to-r from-blue-500 to-green-500 rounded-full mb-6">
            {/* <FaAward className="text-2xl text-white" /> */}
          {/* </div> */}
          <h2 className="text-5xl lg:text-6xl font-bold mb-4 bg-gradient-to-r from-gray-800 to-gray-600 bg-clip-text text-transparent">
            Why Choose <span className="text-[#6BAF92]">
                Kisan Mithraa Mobile Starter ?
            </span>
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            Revolutionary smart technology that transforms traditional farming into intelligent agriculture
          </p>
        </div>

        {/* Main Content */}
        <div className={`transition-all duration-700 ease-in-out ${currentBenefit.bgColor} rounded-3xl p-8 lg:p-12 `}>
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            
            {/* Content Side */}
            <div className="space-y-8">
              {/* Icon & Title */}
              <div className="space-y-4">
                <div className={``}>
                  
                </div>
                <div>
                  <h3 className="text-3xl lg:text-4xl font-bold text-[#6BAF92] mb-2">
                    {currentBenefit.title}
                  </h3>
                  <p className={`text-lg font-medium bg-gradient-to-r ${currentBenefit.color} bg-clip-text text-transparent`}>
                    {currentBenefit.subtitle}
                  </p>
                </div>
              </div>

              {/* Description */}
              <p className="text-gray-700 text-lg leading-relaxed">
                {currentBenefit.description}
              </p>

              {/* Key Features */}
              <div className="space-y-3">
                <h4 className="text-lg font-semibold text-[#6BAF92] ">Key Benefits:</h4>
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-3   ">
                  {currentBenefit.keyFeatures.map((feature, index) => (
                    <div 
                      key={index}
                      className="flex items-center space-x-3 p-3 bg-[#6BAF92]  rounded-lg shadow-sm transform transition-all duration-300 hover:shadow-md hover:scale-105 text-white"
                    >
                      <div className={`w-2 h-2 rounded-full bg-gradient-to-r ${currentBenefit.color}`}></div>
                      <span className="text-white font-lg">{feature}</span>
                    </div>
                  ))}
                </div>
              </div>
            </div>

            {/* Image Side */}
            <div className="relative">
              <div className="relative overflow-hidden justify-center flex items-center ">
                <Image
                  src={currentBenefit.image}
                  alt={currentBenefit.title}
                  height={450}
                  width={450}
                  className=" w-[1/2] transform transition-transform duration-700 hover:scale-105"
                />
                <div className={`absolute inset-0 bg-gradient-to-t ${currentBenefit.color} opacity-10`}></div>
              </div>
              
              {/* Navigation Arrows */}
              {/* <button
                onClick={handlePrevious}
                className="absolute left-4 top-1/2 -translate-y-1/2 w-12 h-12 bg-white/90 backdrop-blur-sm rounded-full shadow-lg flex items-center justify-center transition-all duration-300 hover:bg-white hover:shadow-xl hover:scale-110 group"
                aria-label="Previous benefit"
              >
                <FaChevronLeft className="text-gray-600 group-hover:text-gray-800 transition-colors" />
              </button>
              
              <button
                onClick={handleNext}
                className="absolute right-4 top-1/2 -translate-y-1/2 w-12 h-12 bg-white/90 backdrop-blur-sm rounded-full shadow-lg flex items-center justify-center transition-all duration-300 hover:bg-white hover:shadow-xl hover:scale-110 group"
                aria-label="Next benefit"
              >
                <FaChevronRight className="text-gray-600 group-hover:text-gray-800 transition-colors" />
              </button> */}
            </div>
          </div>
        </div>

        {/* Navigation Dots */}
        <div className="flex justify-center space-x-3 mt-12">
          {benefits.map((_, index) => (
            <button
              key={index}
              onClick={() => handleDotClick(index)}
              className={`transition-all duration-300 rounded-full ${
                index === currentIndex
                  ? `w-12 h-4 bg-gradient-to-r ${benefits[index].color}`
                  : "w-4 h-4 bg-gray-300 hover:bg-gray-400"
              }`}
              aria-label={`Go to benefit ${index + 1}`}
            />
          ))}
        </div>

        {/* Auto-play Control */}
        <div className="flex justify-center mt-6">
          {/* <button
            onClick={() => setIsAutoPlaying(!isAutoPlaying)}
            className={`px-4 py-2 rounded-full text-sm font-medium transition-all duration-300 ${
              isAutoPlaying
                ? "bg-gray-200 text-gray-600 hover:bg-gray-300"
                : "bg-blue-500 text-white hover:bg-blue-600"
            }`}
          >
            {isAutoPlaying ? "Pause Auto-play" : "Resume Auto-play"}
          </button> */}
        </div>

        {/* Bottom CTA */}
        <div className="px-6 py-10  border-t border-slate-700">
        <div className="max-w-4xl mx-auto text-center space-y-8">
          <h2 className="text-4xl lg:text-5xl font-bold  text-black">
            Ready to Go With <span className="text-[#5EA785]">Mobile Starter?</span>
          </h2>
          <p className="text-xl text-black">
            Transform your motor control experience with Mobile Starter.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <button className="px-8 py-4 bg-[#6BAF92]  hover:bg-[#5EA785] text-white text-sm font-medium rounded-full shadow-md transition-all duration-300 hover:shadow-lg hover:scale-105">
              <span className="flex items-center gap-2 justify-center">
                {/* <Power0 className="w-5 h-5 group-hover:rotate-180 transition-transform duration-500" /> */}
                <a href="/Order"  rel="noopener noreferrer">
                Order Now
                </a>
              </span>
            </button>
            <button className="px-8 py-4 bg-white  hover:bg-[#5EA785] text-black text-sm font-medium rounded-full shadow-md transition-all duration-300 hover:shadow-lg hover:scale-105 hover:text-white">
             <a href="/ContactUs"  rel="noopener noreferrer">
              Contact Sales
              </a>
            </button>
            
          </div>
        </div>
      </div>
      </div>
    </section>
  );
}